import { useState } from "react";

import { Box, Typography } from "@mui/material";

import { FrmTextField } from "components/formFields/FrmTextField";
import { FieldHelperText } from "components/utility/FieldHelperText";

import { i18n } from "services/i18nService";
import { validateDomain } from "services/sosInventoryService/sosApi";

export function FrmCustomerPortalSubdomain(props) {
  const { value, onValueChange, name, sx } = props;
  const [error, setError] = useState(false);

  async function handleValueChange(name, value) {
    onValueChange(name, value);
    if (!value) {
      setError(false);
      return;
    }
    const { success, data } = await validateDomain(value);
    if (success) {
      setError(!data.available);
    }
  }

  return (
    <Box sx={sx}>
      <FrmTextField
        name={name}
        value={value}
        onValueBlur={handleValueChange}
        maxLength={100}
        error={error}
      />
      {error ? (
        <FieldHelperText color="warning.error">
          {i18n("settings.sales.customerPortal.portalDomain.warning")}
        </FieldHelperText>
      ) : (
        <>
          <Typography variant="helperText" component="div">
            {i18n("settings.sales.customerPortal.portalDomain.addressLabel") +
              ":"}
          </Typography>
          <Typography variant="helperText" component="div">
            {value ? `https://${value}.orderfacts.com` : ""}
          </Typography>
        </>
      )}
    </Box>
  );
}
